export const HOTELS_FILTERS_ROUTE = 'hotels-filters';
export const HOTEL_RESULTS_ROUTE = 'hotel-results';
export const HOTEL_BYHOURS_ROUTE = 'byhour';
export const HOTEL_BYHOURS_RESULTS_ROUTE = 'byhours-results';
